<template>
  <span class="mention">
    <slot />
  </span>
</template>

<style scoped>
  .mention {
    background-color: rgb(var(--v-theme-border));
    border-radius: 10px;
    padding: 0 5px 2px 5px;
    margin: 5px;
  }
</style>
